import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import Section from "components/Layout/Section"
import SimpleHeader from "components/Layout/SimpleHeader"
import * as css from "./ProofCards.module.css"

function isExternal(url) {
  return /^https?:\/\//.test(url || "")
}

function ProofCards({
  label,
  heading,
  description,
  descriptionHtml,
  cards,
  footerHtml,
  footer,
}) {
  const subtitle = descriptionHtml ? (
    <span dangerouslySetInnerHTML={{ __html: descriptionHtml }} />
  ) : (
    description
  )

  return (
    <Section padding="extraLight">
      <SimpleHeader
        label={label}
        title={heading}
        subtitle={subtitle}
        dash="vertical"
        narrow="both"
      />
      {cards?.length > 0 && (
        <div className={css.grid}>
          {cards.map((card, index) => {
            const cardClass = `${css.card} ${card.link ? css.cardLink : ""}`
            const inner = (
              <>
                {card.category && (
                  <p className={css.category}>{card.category}</p>
                )}
                <h3 className={css.heading}>{card.heading}</h3>
                {card.link && <span className={css.arrow}>Read story →</span>}
              </>
            )

            if (!card.link) {
              return (
                <div key={`proof-card-${index}`} className={cardClass}>
                  {inner}
                </div>
              )
            }

            if (isExternal(card.link)) {
              return (
                <a
                  key={`proof-card-${index}`}
                  href={card.link}
                  className={cardClass}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {inner}
                </a>
              )
            }

            return (
              <Link
                key={`proof-card-${index}`}
                to={card.link}
                className={cardClass}
              >
                {inner}
              </Link>
            )
          })}
        </div>
      )}
      {(footerHtml || footer) && (
        <div className={css.footer}>
          {footerHtml ? (
            <span dangerouslySetInnerHTML={{ __html: footerHtml }} />
          ) : (
            footer
          )}
        </div>
      )}
    </Section>
  )
}

ProofCards.propTypes = {
  label: PropTypes.string,
  heading: PropTypes.string.isRequired,
  description: PropTypes.string,
  descriptionHtml: PropTypes.string,
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      category: PropTypes.string,
      heading: PropTypes.string.isRequired,
      link: PropTypes.string,
    })
  ),
  footer: PropTypes.string,
  footerHtml: PropTypes.string,
}

export default ProofCards
